import { combineReducers } from 'redux'

import { commonReducer } from './common/reducer'
import { paymentReducer } from './payment/reducer'
import { subscriptionReducer } from './subscription/reducer'
import { IAppState } from './types'
import { userReducer } from './user/reducer'

export const rootReducer = combineReducers<IAppState>({
  common: commonReducer,
  user: userReducer,
  payment: paymentReducer,
  subscription: subscriptionReducer,
})
